import { Stat } from '@/components/ui';

interface MetricProps {
  value: string;
  label: string;
  tone?: 'accent' | 'plain' | 'muted';
}

export function Metric({ value, label, tone = 'accent' }: MetricProps) {
  return <Stat value={value} label={label} tone={tone === 'plain' ? 'ink' : tone} />;
}
